import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledWrapper = styled(Box)({
  width: "100%",
  minWidth: "300px",

  height: "300px",
  marginBottom: "40px",
});

export const StyledChartContainer = styled(Box)({
  width: "100%",
  height: "100%",
});

export const StyledLegendContainer = styled(Box)({
  maxHeight: "40%",
  minHeight: 0,
  width: "100%",
  overflowY: "auto",
  overflowX: "hidden",
  borderTop: "1px solid #ebebf7",

  "ul > div > span": {
    display: "none",
  },
});
